import { render, staticRenderFns } from "./TheItemsView.vue?vue&type=template&id=52c76200&scoped=true"
import script from "./TheItemsView.vue?vue&type=script&lang=js"
export * from "./TheItemsView.vue?vue&type=script&lang=js"
import style0 from "./TheItemsView.vue?vue&type=style&index=0&id=52c76200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c76200",
  null
  
)

export default component.exports